// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mJBFg","option":"styles_option__OBZDr","active":"styles_active__pRdwr"};